import { createActions, createReducer } from 'reduxsauce';
import cloneDeep from 'lodash/cloneDeep';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    loading: false,
    error: '',
    success: false,
    list: [],
    userType: '',
    loadingData: false,
    data: {},
    showDetails: false,
};

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    updateProperty: ['property', 'value'],
    updateProperties: ['values'],
    reset: [],
}, { prefix: '@users/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.UPDATE_PROPERTY]: (state, { property, value }) => ({
        ...cloneDeep(state),
        [property]: value,
    }),

    [Types.UPDATE_PROPERTIES]: (state, { values }) => ({
        ...cloneDeep(state),
        ...values,
    }),

    [Types.RESET]: () => (cloneDeep(INITIAL_STATE)),
});

export default Creators;